import { Injectable } from '@angular/core';
import { ActivityComponentUIState } from './activity-component.uistate';
import { HttpService } from '@ecp-caf/caf-common';
import { map } from 'rxjs/operators';
import { BizComponentEntity, ComponentLocation, OwnerType } from '../../domain/entities/biz-component.entity';
import { GspComponent } from '@gsp-cmp/common-component';
import { ActualParameter } from '../../domain/entities/actual-parameter';
import { Parameter } from '@ecp-caf/common-structure';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { Subject } from 'rxjs';
import { ProcessDeUtil } from '../../domain/process-de-util';
@Injectable()

export class ActivityComponentRepository {
    private defaultProcessComponentIds = ['5863c8a8-e0a7-4137-a8b2-4c05e42b3b73', 'be781ba1-a88b-4bb8-9c88-2e2a27a9226e'];

    subject: Subject<BizComponentEntity> = new Subject<BizComponentEntity>();
    constructor(
        private uistate: ActivityComponentUIState,
        private util: ProcessDeUtil,
        private http: HttpService,
        private designerState: ProcessDesignerUIState,
    ) { }

    loadComponents(flowFormId: string, bizActId: string) {
        let url = this.util.getBizComponentsWebApi();
        if (bizActId) {
            url += `/query?param=` + encodeURIComponent(`{"flowFormKey":"${flowFormId}","owner":"${bizActId}","ownerType":"Activity"}`);
        } else {
            this.uistate.allComponents = [];
            return;
        }
        this.http.get(url).subscribe((data: any) => {
            this.uistate.allComponents = data.filter((c: BizComponentEntity) => c.ownerType === OwnerType.Activity);
        });
    }
    removeComponent(id: string) {
        if (id) {
            this.uistate.components = this.uistate.components.filter(c => c.id !== id);
        }
    }
    addComponent(cpt: GspComponent) {
        if (cpt) {
            const component = new BizComponentEntity(cpt.name, cpt.id, cpt.operations[0].code);
            component.id = ProcessDeUtil.GenerateElementId();
            component.actualParameters = this.bindParas(cpt);
            console.log(cpt);
            console.log(component.actualParameters);
            if (component.metadataId === '7433df25-9260-4c24-86f0-9da3e89450fb' ||
            component.metadataId === 'd0783800-ed60-488c-b053-8806a15947fe' ||
            component.metadataId === 'b89e9b9a-2e2d-4bd0-b354-187219544d34' ||
            component.metadataId === 'a8b8f7a4-49ae-4b7d-88d2-b3772b9d0ae5' ) {
              component.scopeType = 'ExternalProcess';
            } else {
              component.scopeType = 'DirectStart';
            }
            this.uistate.components.push(component);
            this.subject.next(component);
        }
    }
    private bindParas(component: GspComponent): ActualParameter[] {
        let parameters = [];

        if (component.operations[0].parameters && component.operations[0].parameters.length > 0) {
            if (this.defaultProcessComponentIds.indexOf(component.id) > -1) {
                parameters = this.assignParameterValue(component.operations[0].parameters);
            } else {
                parameters = component.operations[0].parameters.map(p => ({ code: p.code, name: p.name, value: '' }));
            }
        }
        return parameters;
    }
    private assignParameterValue(params: Parameter[]): ActualParameter[] {
        return params.map(p => {
            if (p.code.indexOf('beId') > -1) {
                const v = this.designerState.formalParameterContext.filter(c => c.key.indexOf('metadataId') > -1)[0].key;
                return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"${v}\\")"}` };
            } else if (p.code.indexOf('nodeId') > -1) {
                const v = this.designerState.formalParameterContext.filter(c => c.key.indexOf('schemaId') > -1)[0].key;
                return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"${v}\\")"}` };
            } else if (p.code.indexOf('dataId') > -1) {
                return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"dataId\\")"}` };
            } else if (p.code.indexOf('procInstId') > -1) {
                return { code: p.code, name: p.name, value: `{"expr":"DefaultFunction.GetContextParameter(\\"procInstId\\")"}` };
            } else {
                return { code: p.code, name: p.name, value: '' };
            }
        });
    }

    swapArray(arr: Array<any>, i1: number, i2: number): Array<any> {
        arr[i1] = arr.splice(i2, 1, arr[i1])[0];
        return arr;
    }

  // 获取是否预制了外部流程构件
  getBizCmp(hander: any) {
    const url = `/api/runtime/wf/v1.0/bizComponent?flowFormKey=*&owner=*&ownerType=Process`;
    this.http.get(url).subscribe((data: any) => {
      hander(data);
    });
  }
}
